import { SET_SUGGESTION_MESSAGE } from "./types";

export const setSuggestionMessage = (message) => (dispatch) => {
  dispatch({
    type: SET_SUGGESTION_MESSAGE,
    payload: message,
  });
};
